<template>
  <div class="table_margin_0">
    <div class="title_h1">作業可能日調整</div>
    <vab-query-form
      ref="queryForm"
      class="dpform DPR01G01"
      :model="queryForm"
      :rules="rules"
      size="mini"
      label-width="98px"
      @search="fetchData"
    >
      <vab-row :gutter="20">
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-date-picker
            type="month"
            placeholder="開始月"
            label="依頼年月"
            value-format="yyyy/MM/01"
            format="yyyy/MM"
            prop="requestYearMonth"
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            label="可能日調整状況"
            prop="requestStatusList"
            filter="requestStatus"
            class="label_height"
            collapse-tags
            clearable
            multiple
          />
        </vab-col>

        <vab-col :lg="8" :xl="8" :md="12">
          <!-- <CommonSelect
            label="依頼部門"
            :componentcd.sync="queryForm.workableDateRequest.requestDepCd"
            cname="Department"
          /> -->
          <vab-input label="提出依頼部門" prop="requestDepName"></vab-input>
          <!-- <Department
            :componentcd.sync="queryForm.requestDepCdList"
            :code-enum="$divisions.morgnznpEnum.enum_5"
            :span1="6"
            :span2="18"
          /> -->
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <!-- <CommonSelect
            label="依頼者"
            :componentcd.sync="queryForm.workableDateRequest.requestPersonCd"
            :single="true"
            cname="Bearer"
          /> -->
          <vab-input
            label="提出依頼担当者"
            prop="requestPersonName"
            class="label_height"
            show-after="半角ｶﾅ"
          ></vab-input>
          <!-- <Contacts
            :code-enum="$divisions.integratedEmployeesEnum.enum_10"
            :componentcd.sync="queryForm.requestPersonCdList"
            :span1="6"
            :span2="18"
          /> -->
        </vab-col>
      </vab-row>
    </vab-query-form>
    <el-row>
      <el-col>
        <vab-table
          ref="table"
          api-url="/api/workableDateRequest/partner/pager"
          :columns="columns"
          :query-params="{
            ...queryForm,
            sidx: 'possibleDateDetailId',
            sort: 'desc',
          }"
          :init-params="{
            ...queryForm,
            sidx: 'possibleDateDetailId',
            sort: 'desc',
          }"
          primary-key="possibleDateDetailId"
          :enable-init="reloadPage"
          :span="20"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import reload from '@/utils/reload'

  export default {
    name: 'PWS02G05',
    extends: reload,
    data() {
      return {
        rules: {},
        queryForm: {
          requestStatusList: [],
          requestYearMonth: null,
        },
        navButtons: [
          {
            name: '日程提出催促',
            type: 'primary',
            click: this.stLogin,
          },
          {
            name: '書類提出催促',
            type: 'primary',
            click: this.jsLogin,
          },
        ],
        columns: [
          {
            sortable: true,
            label: '依頼年月',
            width: 120,
            prop: 'possibleDateReqIdModel.requestYearMonth',
            formatter: (row, column, cellValue) => {
              if (cellValue) {
                return this.$dayjs(cellValue).format('YYYY/MM')
              }
              return ''
            },
          },
          {
            label: '可能日調整状況',
            sortable: true,
            width: 140,
            prop: 'requestStatus',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.requestStatusEnum
              )
            },
          },
          {
            sortable: true,
            label: '提出依頼部門',
            prop: 'possibleDateReqIdModel.requestDepCdModel.orgkj',
          },
          {
            label: '提出依頼担当者',
            sortable: true,
            width: 250,
            prop: 'possibleDateReqIdModel.requestPersonCdModel.empnmkj',
          },
          {
            label: '協力会社',
            sortable: true,
            width: 250,
            prop: 'requestDestCdModel.bcnfrkj',
          },
          {
            // 按钮
            type: 'actions',
            label: '操作',
            fixed: 'right',
            disableCheck: true,
            width: '120',
            info: '詳細',
            click: (row) => {
              this.$routerPush({
                name: 'PWS02G06',
                query: { possibleDateDetailId: row.possibleDateDetailId },
              })
            },
          },
        ],
      }
    },
    created() {},
    methods: {
      // 検索ボタン
      fetchData() {
        this.$refs.table.fetchData()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .item_box {
    padding-right: 8px;
    padding-top: 10px;
    .sub_title {
      font-weight: 400;
      font-size: 12px;
      color: #848484;
      line-height: 28px;
    }
    .sub_buttom {
      display: inline-block;
      padding: 0 10px;
      line-height: 28px;
      background: #f7f7f7;
      border: 1px solid #efefef;
      border-radius: 4px;
      font-weight: 400;
      font-size: 12px;
      color: #003350;
      padding-right: 30px;
      background: url('~@/assets/images/close.png') right 8px center no-repeat,
        #f7f7f7;
    }
  }
</style>
